// extracted by mini-css-extract-plugin
export default {"main_container":"UserMyAdsDetail_main_container__hsZ5g","edit_btn":"UserMyAdsDetail_edit_btn__uaP30","delete_btn":"UserMyAdsDetail_delete_btn__RwGdi"};